import { EpetJs } from '@/utils/epetsdk'
var host = {
    local: 'http://i.dev.epet.com/api',
    dev: 'http://i.dev.epet.com/api',
    product: 'http://i.epet.com/api',
}
var host_base_url =
    process.env.NODE_ENV == 'development' ? 'http://i.dev.epet.com/api' : host[EpetJs.Const.ENV]

var host_php_gate = {
    local: 'http://192.168.10.222:9009',
    dev: 'http://47.99.3.112:9009',
    product: 'http://118.31.218.212:9009',
    version: 'v1',
}
var host_php_gate_url =
    process.env.NODE_ENV == 'development'
        ? 'http://47.99.3.112:9009/v1'
        : host_php_gate[EpetJs.Const.ENV] + '/' + host_php_gate.version

var host_php = {
    local: 'http://ecteam.local.epetbar.com',
    dev: 'http://ecteam.dev.tapinpet.com',
    product: 'http://ecteam.tapinpet.com',
}
var host_php_url =
    process.env.NODE_ENV == 'development'
        ? 'http://ecteam.dev.tapinpet.com'
        : host_php[EpetJs.Const.ENV]

var host_java = {
    local: 'http://192.168.10.19:8085',
    dev: 'http://101.37.146.235:8085',
    product: 'https://javaapi.epetbar.com',
    version: 'v1.00',
}
var host_java_url =
    process.env.NODE_ENV == 'development'
        ? 'http://101.37.146.235:8085/v1.00'
        : host_java[EpetJs.Const.ENV] + '/' + host_java.version

var host_haiji = {
    local: 'http://192.168.10.222:9206',
    dev: EpetJs.Const.PROTOCOL + '//alliance-api.dev.haijipet.com',
    product: EpetJs.Const.PROTOCOL + '//allianceapi.tapinpet.com'
}
var host_haiji_url =
    process.env.NODE_ENV == 'development'
        ? host_haiji['dev']
        : host_haiji[EpetJs.Const.ENV]
var host_admin_default = {
    local: 'http://192.168.0.222:8888',
    dev: 'http://adminapi.dev.tapinpet.com',
    product: EpetJs.Const.PROTOCOL + '//adminapi.tapinpet.com',
    version: 'v1'
}
var host_admin_func = function (serveName) {
    return process.env.NODE_ENV == 'development' ? host_admin_default['dev'] + '/' + serveName + '/' + host_admin_default.version : host_admin_default[EpetJs.Const.ENV] + '/' + serveName + '/' + host_admin_default.version
}

var host_sso = {
    local: 'http://sso.local.epetbar.com',
    dev: EpetJs.Const.PROTOCOL + '//sso.dev.tapinpet.com',
    product: EpetJs.Const.PROTOCOL + '//sso.tapinpet.com',
    version: 'v1'
}
var host_sso_url = process.env.NODE_ENV == 'development' ? `${host_sso['dev']}/${host_sso.version}` : host_sso[EpetJs.Const.ENV] + '/' + host_sso.version

var host_admin_gateway_default = {
    local: '',
    dev: EpetJs.Const.PROTOCOL + '//adminapi-gateway.dev.tapinpet.com',
    product: EpetJs.Const.PROTOCOL + '//adminapi-gateway.tapinpet.com',
    version: 'v1'
}
var host_admin_gateway_func = function(serveName,version='v1') {
    if (version) {
        return process.env.NODE_ENV == 'development' ? host_admin_gateway_default['dev'] + '/' + serveName + '/' + version : host_admin_gateway_default[EpetJs.Const.ENV] + '/' + serveName + '/' + version
    } else {
        return process.env.NODE_ENV == 'development' ? host_admin_gateway_default['dev'] + '/' + serveName : host_admin_gateway_default[EpetJs.Const.ENV] + '/' + serveName
    }
}

export {
    host_base_url,
    host_php_url,
    host_java_url,
    host_php_gate_url,
    host_haiji_url,
    host_admin_func,
    host_sso_url,
    host_admin_gateway_func 
}
